import { css, keyframes } from "styled-components";

import { colorIsLight, lightenDarkenColor } from "Utilities/Colors/colorUtils";

const flashAnimation = (fromColor, toColor) => keyframes`
  from {
    border-color: ${fromColor};
  }
  to {
    border-color: ${toColor};
  }
`;

const borderFlash = ({
  $isFlashing,
  $color = "#ffffff00",
  $flashToColor = lightenDarkenColor($color, colorIsLight($color) ? -60 : 60),
}) =>
  $isFlashing
    ? css`
        animation: ${flashAnimation($color, $flashToColor)} 0.5s ease-in-out
          infinite alternate;
      `
    : "";

/**
 * Generates CSS string for a flashing border animation (for dynamic injection)
 * @param {string} selector - CSS selector for the element (e.g., '.my-element.flashing')
 * @param {string} color1 - Starting/ending border color
 * @param {string} color2 - Middle border color
 * @returns {string} Complete CSS string with keyframes and class
 */
export const generateBorderFlashStyles = ({ selector, color1, color2 }) => {
  return `
    @keyframes border-flash {
      0%, 100% {
        border-color: ${color1};
      }
      50% {
        border-color: ${color2};
      }
    }

    ${selector} {
      animation: border-flash 1s ease-in-out infinite !important;
    }
  `;
};

export default borderFlash;
